import React, { useCallback } from 'react';
import { theme } from 'theme';

interface CustomChartDotProps {
  cx: number;
  cy: number;
  payload: { index: number };
  setSelectedPointIndex: (index: number) => void;
}

export const CustomChartDot = ({
  cx,
  cy,
  payload,
  setSelectedPointIndex,
}: CustomChartDotProps) => {
  const handleDotClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      setSelectedPointIndex(payload.index);
    },
    [payload.index, setSelectedPointIndex],
  );

  if (cx === undefined || cy === undefined || !payload) return null;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={5}
      fill={theme.palette.primary.main}
      stroke="white"
      strokeWidth={2}
      style={{ cursor: 'pointer' }}
      onClick={handleDotClick}
    />
  );
};
